import React from 'react';
import PriceSummary from '@homeaway/react-price-summary';

// Component to use for error states
export const NoPriceLabel = ({noPrice}) => (<div><small className="rate">{noPrice}</small></div>);

// helper function for mapping our legacy prop names to props for <PriceSummary />
const mapHitPricePropsToPriceSummary = ({rate, ratesUnitOfMeasure, edapEventJson = ''}) => ({
    formattedAmount: rate,
    pricePeriodDescription: ratesUnitOfMeasure,
    edapEventJson
});

export const isRateless = ({rate, ratesUnitOfMeasure}) => !rate || !ratesUnitOfMeasure;

// main component that determines which pricing component to display
const HitPrice = (props) => {
    if (isRateless(props)) {
        return <NoPriceLabel noPrice={props.noPrice} />;
    }
    return (<PriceSummary priceSummary={mapHitPricePropsToPriceSummary(props)}/>);
};

export default HitPrice;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitPrice/HitPrice.js